import { useEffect, useState } from "react";
import { Download, FileText, ChevronRight } from "lucide-react";
import { http, notify, can } from "../api";
import { Loading } from "./common";

export default function Documents({ user, onSelect }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    http.get("/documents")
      .then((r) => setItems(r.data))
      .catch((err) => notify.error(err, "Could not load documents"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const download = async (doc) => {
    try {
      const r = await http.get(`/documents/${doc.document_id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url; a.download = doc.filename; a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      notify.error(err, "Could not download document");
    }
  };

  const canView = can(user, "view_documents");

  if (!canView) {
    return (
      <>
        <div className="page-intro">
          <div>
            <p className="eyebrow">CONTROLLED FILES / CUSTOMER RECORDS</p>
            <h1>Documents</h1>
            <p className="muted">You do not have permission to view documents.</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page-intro">
        <div>
          <p className="eyebrow">CONTROLLED FILES / CUSTOMER RECORDS</p>
          <h1>Documents</h1>
          <p className="muted">Every uploaded file, attached to a permitted lead.</p>
        </div>
      </div>
      {loading ? (
        <Loading>Loading documents…</Loading>
      ) : items.length === 0 ? (
        <div className="empty-state">
          <div className="file-icon"><FileText size={24} /></div>
          <h3>No documents yet</h3>
          <p>Open a permitted lead to attach PAN, income proof, salary slips, or bank statements.</p>
          <button data-testid="documents-open-leads-button" className="outline-button" onClick={() => onSelect?.(null)}>
            Browse leads <ChevronRight size={15} />
          </button>
        </div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Filename</th>
                <th>Lead</th>
                <th>Uploaded by</th>
                <th>Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((d) => (
                <tr key={d.document_id || d.stored_name} data-testid={`documents-row-${d.document_id}`}>
                  <td><strong>{d.document_type}</strong></td>
                  <td>{d.filename}</td>
                  <td className="mono">
                    <button className="link-button" onClick={() => onSelect?.(d.lead_id)}>{d.lead_id}</button>
                  </td>
                  <td>{d.uploaded_by}</td>
                  <td className="muted">{d.created_at?.slice(0, 10)}</td>
                  <td>
                    {d.document_id && (
                      <button
                        className="icon-button"
                        onClick={() => download(d)}
                        aria-label="Download"
                        data-testid={`documents-download-${d.document_id}`}
                      >
                        <Download size={15} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
